import { render, staticRenderFns } from "./BuddiesList.vue?vue&type=template&id=09dd02f7&scoped=true"
import script from "./BuddiesList.vue?vue&type=script&lang=js"
export * from "./BuddiesList.vue?vue&type=script&lang=js"
import style0 from "./BuddiesList.vue?vue&type=style&index=0&id=09dd02f7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09dd02f7",
  null
  
)

export default component.exports